import React from 'react';
import styled from 'styled-components';

import Chart from '../Chart';
import Statistic from '../Statistics'; 

const defaultConfig = {
  // width: 180,
  // height: 160,
  rangeSize: 13,
  pivot: {
    visible: true,
    thickness: 4,
    pointer: {
      visible: true,
      style: {
        fill: "#104663"
      }
    },
    base: {
      size: 15
    },
    pin: {
      visible: true,
      style: { fill: "#e8e6ea" }
    }
  },
  rangeBackgroundStyle: {
    fill: '#DAE0E6',
  }
};

const TotalCphGauge = ({ value, max, statProps = {}, config = {}, ...rest }) => {
  const hasValue = typeof value !== 'undefined';
  const hasMax = typeof max !== 'undefined';

  value = typeof value === 'undefined' ? 0 : value;
  max = typeof max === 'undefined' ? value : max;

  let val;

  if (hasValue && hasMax) {
    val = Math.min(Math.round(value * 10 / max) / 10, 1);
  } else {
    val = 0;
  }

  const rangeColors = ['0:#F5222D'];

  if (val >= 0.6) {
    rangeColors.push('0.4:#FAAD14');
    rangeColors.push('1:#52C41A');
  } else if (val >= 0.4) {
    rangeColors.push('1:#FAAD14');
  }

  config = Object.assign({}, defaultConfig, config, {
    value: val,
    min: 0,
    max: 1,
    range: [0, val],
    color: [`l(0) ${rangeColors.join(' ')}`],
    axis: {
      tickLine: { visible: false },
      label: { visible: false }
    },
  });

  if (typeof config.width === 'number') {
    config.rangeSize = Math.floor(config.width / 15);
  }

  return (
    <TotalCphGaugeWrapper {...rest}>
      <Chart type="gauge" config={config} />
      <Statistic
        title="Total CPH"
        value={hasValue ? Math.round(value) : 'N/A'}
        titleAlign={['center', 'bottom']}
        {...statProps}
      />
    </TotalCphGaugeWrapper>
  );
};

const TotalCphGaugeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default TotalCphGauge;
